/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: bf0f7e855303
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * Static asset delivery type.
 */
export const AssetDeliveryType = {
  Asset: "asset",
} as const;
/**
 * Static asset delivery type.
 */
export type AssetDeliveryType = ClosedEnum<typeof AssetDeliveryType>;

export const AssetDeliveryType$zodSchema = z.enum([
  "asset",
]).describe("Static asset delivery type.");
